//
// Module for the Batch Adjustment wizard Batch step
//
rs.module("jobs/criteria/batchadjustment/batchstep",

    ["common/visibility"],

    function (visibility) {

        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var applyColaCheckBox = stepContainer.js(jsSelectors.applyColaCheckBox, { required: false });
            var cpiPercentInput = stepContainer.js(jsSelectors.cpiPercentInput, { required: false });
            var ratePercent = stepContainer.js(jsSelectors.ratePercent, { required: false });
            var ratePercentHidden = stepContainer.js(jsSelectors.ratePercentHidden, { required: false });
            var rateAmount = stepContainer.js(jsSelectors.rateAmount, { required: false });
            var rateAmountHidden = stepContainer.js(jsSelectors.rateAmountHidden, { required: false });
            var balanceParamsContainer = stepContainer.js(jsSelectors.balanceParamsContainer);

            // Enable/Disable/Clear cpiPercent input on applyColaCheckBox change
            applyColaCheckBox.change(function () {
                cpiPercentInput.prop("disabled", !this.checked).val("").clearErrors();
            });

            // Hookup ratePercent and rateAmount change events
            ratePercent.change(ratePercentChange);
            rateAmount.change(rateAmountChange);

            // On Rate Percent change  
            function ratePercentChange() {

                // If a ratePercent is entered, disable and clear the rateAmount
                rateAmount.prop('disabled', ratePercentHasValue());
                if (ratePercentHasValue()) {
                    rateAmount.val("").clearErrors();
                    rateAmountHidden.val("");
                }

                // If applyColaCheckBox is disabled, enable it and disable it's dependent field (cpiPercentInput)
                if (applyColaCheckBox.prop('disabled') == true) {
                    applyColaCheckBox.prop('disabled', false);
                    cpiPercentInput.prop('disabled', true);
                }

                // Always show the balanceParamsContainer
                visibility.setVisible(balanceParamsContainer, true);
            }

            // Return true if rate percent has a nonzero value
            function ratePercentHasValue() {
                return $.getNormalizedPercentValue(ratePercent.val()) != 0;
            }

            // On Rate Amount change 
            function rateAmountChange() {

                // If a rateAmount is entered, enable/disable/clear dependent fields
                if (rateAmountHasValue()) {
                    ratePercent.prop('disabled', true).val("").clearErrors();
                    ratePercentHidden.val("");
                    applyColaCheckBox.prop('disabled', true);
                    applyColaCheckBox.setChecked(false);
                    cpiPercentInput.prop('disabled', true).val("").clearErrors();
                }
                // If the rateAmount was cleared or equals 0, enable/disable dependent fields
                else {
                    ratePercent.prop('disabled', false);

                    if (applyColaCheckBox.prop('disabled') == true) {
                        applyColaCheckBox.prop('disabled', false);
                        cpiPercentInput.prop('disabled', true);
                    }
                }

                // Show the balanceParamsContainer based on a rateAmount being entered
                visibility.setVisible(balanceParamsContainer, !rateAmountHasValue());
            }

            // Return true if rate amount has a nonzero value
            function rateAmountHasValue() {
                return $.getNormalizedCurrencyValue(rateAmount.val()) != 0;
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);